module.exports = __webpack_public_path__ + "img/palette.5ef9bf9b.png";